// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrows-module--arrow--3Lmlc","close":"Arrows-module--close--2OwPE","arrowShadow":"Arrows-module--arrowShadow--3-ZuJ","closeShadow":"Arrows-module--closeShadow--1d9F6"};